export const enTranslations = {
	common: {
		required: 'Required field',
		continue: 'Continue',
		birth_date: 'Date of birth',
		invalid_email: 'Invalid email',
		first_name: 'First name',
		last_name: 'Last name',
		email: 'Email',
		phone_number: 'Phone number',
		page_not_found: 'Page not found',
		pay: 'Pay',
		payed: 'Paid',
		not_payed: 'Not paid',
		free: 'Free',
		open: 'Open',
		or: 'or',
		cancel: 'Cancel'
	},

	login: {
		enter: 'Log in',
		welcome_back: 'Welcome back!',
		enter_email: 'Enter your email',
		wrong_email: 'Incorrect email',
		email_does_not_exist: 'This email does not exist',
		dont_have_account: "Don't have an account?",
		sign_up: 'Sign up',
		sign_in_with: 'Sign in with {{platform}}',
		get_to_know_your_potential: 'Discover your potential today!',
		pass_test_and_get_results:
			'Take the test and receive personalized results by email! Registration takes only 10 seconds.'
	},

	register: {
		sign_up: 'Sign up',
		sign_up_for_test: 'Sign up for the test',
		already_have_account: 'Already have an account?',
		email_already_in_use: 'This email is already in use',
		enter_valid_number: 'Enter a valid number',
		login: 'Log in'
	},

	otp: {
		invalid_otp: 'The code is incorrect, please try again',
		enter_otp: 'Enter the 6-digit code sent to <0>{{email}}</0>',
		resend_available_in: 'Resend will be available in: {{countdown}}s',
		resending: 'Your code is being sent',
		resend: 'Resend 6-digit code to email'
	},
	instructions: {
		get_started: 'Let’s begin',
		sign_up_completed: 'You’ve <0>successfully registered</0>',
		proceed_to_test: 'Now you’re ready to take the test',
		make_sure_have_time:
			'Make sure you have 15–20 minutes of uninterrupted time',
		test_consists_of_100_questions: 'The test consists of 100 questions',
		try_to_spend_20_seconds:
			'Try to answer each question in about 20 seconds',
		no_right_or_wrong_answers:
			'There are no right or wrong answers — just answer honestly'
	},
	profile: {
		my_reports: 'My reports',
		settings: 'Profile settings',
		logout: 'Log out',
		hello: 'Personal information',
		save: 'Save changes',
		cancel: 'Cancel',
		profile_edit: 'Edit profile',
		update_success: 'Your information has been saved',
		update_error: 'Failed to save your information',
		test_breakdown: 'Detailed test reports'
	},
	result: {
		full_report: 'Get full report',
		demo_talents: 'Your top 5',
		prev_question: 'Previous question',
		note: 'Trust your intuition! Your first, spontaneous answer is what matters most in this test.'
	},

	payment: {
		one_time_payment: 'One-time payment for full access',
		access_through_code: 'Get access using the activation code',
		dont_have_access_code: "You don't have an activation code?",
		get_access_code: 'Get the code from the manager'
	},
	report: {
		from: 'Result of',
		retake_test: 'Pass the test',
		empty_reports: "You don't have any reports yet",
		did_not_pass_test:
			'You have not taken any tests yet. Take the test to see the results.',
		full_access_congrats:
			"Congratulations, you've unlocked the full report!",
		send_to_email: 'Your results have been sent to your email.',
		full_view: 'View full report',
		full_report: 'Full Report',
		download_report: 'Download the report'
	},
	errors: {
		unknown: 'An unknown error occurred.'
	},
	assessment_plans: {
		assess_your_talents: 'Assess your talents',
		learn_your_strength: 'Recognize your strengths and develop them',
		increase_involvment: 'More engagement at work',
		increase_productivity: 'Higher productivity',
		increase_life_quality: 'Better quality of life',
		buy_report: 'Buy report',
		buy_full_report: 'Buy full report',
		six_times: '6 times',
		three_times: '3 times',
		most_popular: 'Most popular',
		safe_payment: 'Safe payment',
		instant_access: 'Instant access after payment'
	},
	demo_report: {
		congrats: 'congratulations! You have reached your unique potential.',
		sequence_of_strengths:
			'These talents make you special and offer unique opportunities for development.',
		your_strengths: 'Your strengths',
		concentrate_on: 'Focus on your strengths',
		your_biggest_actives:
			'Your {{number}} major strengths are your most powerful assets. Science shows that they are your greatest chance to succeed in your professional life and be happy in your personal life.',
		congrats_first_step:
			"Congratulations, you've taken the first step to unlocking your potential!",
		want_to_know_more: 'Want to know more? The full report will show you: ',
		your_top5_talents: 'Your top 5 talents with detailed descriptions.',
		brief_overview: 'A brief overview of your other 15 strengths.',
		deep_understanding: 'A deep understanding of your strengths.',
		open_full_report: 'Get the full report',
		ai_breakdown: 'AI analysis of your results',
		course_access: 'Access to courses'
	},
	unlock_demo_report: {
		discover_strength: 'Discover the full power of your talents!',
		your_top_one: `Your top-1 talent is just the beginning. There is much more potential in you that can take you to new heights. Learn about your other key talents.`,
		extended_analysis:
			'An extended analysis of all your top 5 talents and their unique combination.',
		recommendations:
			'Practical recommendations on how to develop each talent',
		exact_steps: 'Specific steps for applying talents in work and life',
		buy_report_by_key_talents: 'Buy key talents report'
	},
	faq: {
		title: 'Frequently Asked Questions',
		how_will_it_help: 'How will purchasing the full report help me?',
		will_it_help1: `The iTalent test you took provides valuable insights, but you only saw 5% of what we can show you. Our full report contains the remaining 95% of insights about your talents and offers a deeper analysis than what you've already read.`,
		will_it_help2: `In addition, our test demonstrates how you can improve your strengths and put them into practice effectively. You will also realize in which areas you can excel the most.`,
		will_it_help3: `If you really want to understand yourself and become the best version of yourself, studying these materials is essential. Consider them as your roadmap to a happier, more successful, and more versatile version of yourself.`,
		may_i_believe: 'Can I trust these results?',
		yes_you_can:
			'Absolutely. The iTalent.kz testing methodology is based on the same studies used by research institutes to determine personality traits. In total, more than 20 million people in the world have taken such tests.',
		how_much_will_it_cost:
			'How much does the test cost and what does it include?',
		first_plan: 'We have two rates:',
		full_report: '1. Full report',
		report_comparison:
			'For comparison, global analogs such as Gallup cost around $59,99.',
		what_will_you_get: 'What you will get:',
		you_will_get1: 'An in-depth analysis of your key talents.',
		you_will_get2: 'A brief overview of your remaining strengths.',
		you_will_get3: 'A complete talent structure.',
		you_will_get4: 'Advice on how to put your talents into practice.',
		second_plan: '2. Top 5 talents report',

		perfect_for:
			'Perfect for those who want to quickly recognize their greatest strengths.',
		you_will_get21: 'An analysis of your five key talents.',
		you_will_get22: 'A structured hierarchy of your talents.',
		you_will_get23: 'Ways to use your talents.',

		for_whom: 'Who can benefit from the test?',
		for_ambitious:
			'1. Purposeful people: identifies the qualities that accelerate the achievement of goals and identifies what may hinder.',
		for_lost:
			'2. Those who are looking for themselves: helps to find their purpose by setting the right direction of development.',
		for_extrasense:
			'3. Relying on intuition: tests intuitive assumptions and shows what you need to focus on first.',
		for_graduates:
			'4. Graduates and students: The test helps you choose the right profession based on your strengths and avoid mistakes.'
	},
	chat: {
		your_completed_reports: 'Your completed tests',
		analysis_your_report:
			'Our AI will help you parse your test results and unlock your full potential',
		enter_message: 'Enter message...',
		ai_might_be_wrong:
			'AI may make errors. We recommend checking important information.',
		sent: 'Sent',
		sending: 'Sending...',
		error: 'Send error',
		failed_to_send_message: 'Failed to send message. Try again.',
		discover_strength:
			'Unlock your potential with artificial intelligence!',
		buy_full_report: 'To analyze with AI you need to buy the “Full Report”',
		start_analysis: 'Start analysis with AI',
		clear_history: 'Clear history',
		history_cleared: 'History cleared'
	},
	ab_assessment_plans: {
		// Hero section
		heroTitle: 'Congratulations! Your report is ready!',
		heroSubtitle:
			'Learn how to unlock your potential and use your talents to succeed',

		// Preview Results
		previewTitle: 'We have already identified your key talents:',
		previewDescription:
			'You already know 10% of your talents. Get a full analysis to maximize your strengths!',
		recommendedAreas: 'Recommended areas to apply your talents',
		areasDescription:
			'Based on your unique profile, the following professional areas would be ideal for you...',
		unlockInfo: 'Unlock this information in the full report',

		// Proof Grid
		accuracy: 'accuracy of talent identification',
		users: 'users have already unlocked their talents',
		productivity: 'increase in productivity after use',
		recommended: 'users recommend the test',
		// Testimonials
		testimonialsTitle: 'What our users are saying',
		testimonial1:
			"Thanks to the iTalent's full report, I realized my strengths and stopped wasting energy on developing ineffective skills. It was like an insight! Now I'm focusing on the right areas.",
		author1: 'Alexandra, HR specialist',
		testimonial2:
			'We used iTalent for our team to understand who would be most effective in which positions. After reassigning roles based on talent, productivity increased by 12%.',
		author2: ' Bota, company executive',
		testimonial3:
			"iTalent helped me decide on my choice of second education. The report had specific recommendations on areas of activity, which is very valuable when you don't know what direction to take.",
		author3: 'Kamila, student',
		// Plans
		plansTitle: 'Select your report',
		functionsHeader: 'Functions',

		basicTitle: 'Top 5 Talent Report',
		standardTitle: 'Full report + AI',
		premiumTitle: 'Full report + AI + online analysis with expert',

		mostPopular: 'Most Popular',
		firstMeeting: 'Basic analysis to quickly understand key strengths',
		standardDescription:
			'In-depth analysis of potential with personalized recommendations from an AI assistant',
		premiumDescription:
			'Premium solution with personalized expert advice for maximum results',
		// Feature names
		keyTalents: 'Define key talents',
		talentDescription: 'Talent description',
		structuralHierarchy: 'Structural hierarchy',
		applicationAreas: 'Talent application areas',
		developmentRecommendations: 'Development recommendations',
		aiAnalysis: 'Analysis using AI',
		careerRecommendations: 'Career advice',
		expertConsultation: 'Consultation with an expert',
		instantAccess: 'Instant access',
		// Feature values
		top3: 'Top-3',
		top5: 'Top 5',
		allTalents: 'All Talents',
		allTalentsWithBreakdown: 'All talents with the analysis',
		brief: 'Brief',
		full: 'Complete',
		detailed: 'Detailed',
		basic: 'Basic',
		personalized: 'Personalized',
		thirtyMinutes: '60-90 minutes',
		// Chips
		top3talents: 'Top 3 talents',
		top5talents: 'Top 5 talents',
		basicDescription: 'Basic вescription',
		fullAnalysis: 'Full analysis',
		recommendations: 'Recommendations',
		aiBreakdown: 'AI analysis',
		consultation: 'Consultation',
		personalBreakdown: 'Personal analysis',
		// Features list items
		feature_basic_1: 'Top 3 of your talents',
		feature_basic_2: 'A brief description of each talent',
		feature_basic_3: 'Basic structural hierarchy',
		feature_basic_4: 'General development guidelines',
		feature_basic_5: 'Instant access after payment',

		feature_standard_1: 'Top 5 of your key talents',
		feature_standard_2: 'Complete analysis of each talent',
		feature_standard_3: 'Applications of your talents',
		feature_standard_4: 'Specific development recommendations',
		feature_standard_5: 'Detailed structural hierarchy',
		feature_standard_6: 'Basic career advice',
		feature_standard_7: 'Instant access after payment',

		feature_premium_1: 'Analyze all your talents',
		feature_premium_2: 'AI analysis of your results',
		feature_premium_3: 'Detailed analysis of key talents',
		feature_premium_4: 'An overview of all your strengths',
		feature_premium_5: 'Complete talent hierarchy structure',
		feature_premium_6: 'Detailed ways to utilize talents',
		feature_premium_7: 'Personalized career advice',
		feature_premium_8: '60-90 minute online debrief with an expert',
		feature_premium_9: 'Instant access after payment',
		// Buttons
		selectButton: 'Select',
		buyReportButton: 'Buy report',
		buyFullReportButton: 'Buy full report ',
		buyFullReportButtonWithBreakdown: 'Buy full report with analysis',
		securePayment: 'Secure Payment',

		// Guarantee
		guaranteeTitle: '100% satisfaction guarantee',
		guaranteeText:
			'If the report does not meet your expectations, we will refund your money within 14 days.',

		// Upgrade callout
		limitedOffer: 'Limited Offer',
		upgradeTitle: 'Get the most out of your test',
		upgradeDescription:
			"You've already taken your test and taken the first step towards self-knowledge. Invest in yourself and get a detailed report that will help you discover more about yourself.",
		getFullReportButton: 'Get full report',
		// FAQ
		faqTitle: 'FAQ',
		faq1_question: 'What is the difference between the tariffs?',
		faq1_answer:
			'The Basic plan provides insight into 3 key talents, Standard provides insight into 5 talents with recommendations on how to use them, and Premium includes a full analysis of all talents, personalized recommendations, and expert advice.',
		faq2_question: 'How accurate are the test results?',
		faq2_answer:
			'iTalent is developed on the basis of modern psychometric techniques and validated on a sample of more than 25,000 people. The test demonstrates high accuracy (98%) in identifying talents and personality strengths.',
		faq3_question: 'How quickly will I get access to the report?',
		faq3_answer:
			'Access to your report is granted instantly upon successful payment. You will be able to view it online or download it in PDF format.',
		faq4_question: 'What do I do with my test results?',
		faq4_answer:
			'Depending on the tariff you choose, you will receive different recommendations on how to apply your talents. You can use the results to choose a career path, improve efficiency in your current job, self-development or professional reorientation.',
		faq5_question: 'Why should I buy the full report?',
		faq5_answer:
			'A basic report provides only a general overview of your key talents, while a full report provides a detailed analysis of all your strengths, specific recommendations on how to apply them, and personalized career advice. The investment in a full report pays off in increased professional effectiveness and job satisfaction.'
	},
	survey: {
		discount: 'DISCOUNT {{percentage}}%',
		take_survey_get_discount: 'Take the survey and get a discount!',
		answer_questions_get_discount:
			'Answer a few questions about your talents and get a {{percentage}}% discount code for any plan',
		take_short_survey: 'Take a short survey',
		your_discount_code: 'Your discount code has been applied!',
		use_code_at_checkout: 'You just need to proceed to checkout',
		short_survey_about_talents: 'Short survey about your talents',
		question_1: "What's most important to you in talent development?",
		question_2: 'How did you learn about our service?',
		question_3: 'Which reports interest you the most?',
		select_answer: 'Select an answer',
		career_growth: 'Career growth',
		personal_development: 'Personal development',
		financial_success: 'Financial success',
		self_realization: 'Self-realization',
		search_engines: 'Search engines',
		social_media: 'Social media',
		from_friends: 'From friends/acquaintances',
		advertising: 'Advertising',
		top_3_talents: 'Top 3 talents',
		top_5_talents: 'Top 5 talents',
		full_report: 'Full report',
		thanks_for_survey: 'Thank you for taking the survey!',
		use_code_for_discount:
			'Use this code at checkout to get a {{percentage}}% discount',
		submit_get_discount: 'Submit and get discount',
		please_answer_all: 'Please answer all questions'
	},
	courses: {
		courses: 'Courses',
		courses_pass: 'Enroll in courses'
	}
};
